import { c as _c } from "react/compiler-runtime";
import { ZoomableImageResponsiveWrapper, type ZoomableImageResponsiveWrapperProps } from '@/components/Zoomable/ZoomableImageResponsiveWrapper';
import { CmsImage, type CmsImageProps } from '../CmsImage';
export interface ZoomableImageProps extends Pick<ZoomableImageResponsiveWrapperProps, 'zoomable'> {
  image: CmsImageProps;
}
export function ZoomableImage(t0) {
  const $ = _c(7);
  const {
    image,
    zoomable
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <CmsImage {...image} enableFocusPoint={false} fill={false} />;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== image.height || $[3] !== image.width || $[4] !== t1 || $[5] !== zoomable) {
    t2 = <ZoomableImageResponsiveWrapper zoomable={zoomable} height={image.height} width={image.width}>{t1}</ZoomableImageResponsiveWrapper>;
    $[2] = image.height;
    $[3] = image.width;
    $[4] = t1;
    $[5] = zoomable;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}